import { remoteStorageAxios } from './remoteStorageAxios'
import { toDomainHttpClient } from './toDomainHttpClient'

export const domainRemoteStorageHttpClient = toDomainHttpClient(remoteStorageAxios, {
  forwardMeta: false,
})
